module.exports = __webpack_public_path__ + "media/img/trip-ico-ef48787edf2decea6f9de99c4be07c8d.svg";